module.exports = __webpack_public_path__ + "common/icon-download-white-52f701a62250e563609e20b15d19b352.svg";